import * as actions from './actions';

export default function (state = {}, action) {
  switch (action.type) {

  case actions.START_EDITING:
    return {
      ...state,
      editing: true,
    };

  case actions.STOP_EDITING:
    return {
      ...state,
      editing: false,
    };

  default:
    return state;
  }
}
